/** 移除 URL 凭据和私有路径；只保留公开变体参数。 */
function publicSupportUrl(value: string): URL | undefined {
  try {
    const url = new URL(value);
    if (
      !/^https?:$/.test(url.protocol) ||
      url.port ||
      /\/(?:checkouts?|carts?|orders?)(?:\/|$)/i.test(
        decodeURIComponent(url.pathname),
      )
    )
      return undefined;
    const variant = url.searchParams.get("variant");
    url.username = "";
    url.password = "";
    url.hash = "";
    url.search = "";
    if (variant && /^\d{1,64}$/.test(variant))
      url.searchParams.set("variant", variant);
    return url;
  } catch {
    return undefined;
  }
}

/** 自述及必要原话也不携带结账链接、购物车密钥或 URL 凭据。 */
export function sanitizeSupportText(value: string): string {
  return value
    .replace(
      /https?:\/\/[^\s<>"']+/gi,
      (url) => publicSupportUrl(url)?.href ?? "[private link omitted]",
    )
    .replace(
      /\b(?:checkout[_ -]?token|cart[_ -]?(?:key|token)|access[_ -]?token|password)\s*[:=]\s*[^\s,;]+/gi,
      "[credential omitted]",
    );
}
